export enum PaymentType {
  SMS_PAYMENT = "SMS_PAYMENT",
  PLAN_PAYMENT = "PLAN_PAYMENT",
  BIOMETRIC_PAYMENT = "BIOMETRIC_PAYMENT",
}
